import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@sdbn/appclient';
import { HttpService } from '@sdbn/appclient';

@Injectable({
  providedIn: 'root'
})
export class AutoWeighingService {

  constructor(private tmcHttpService: HttpService,
              private configurationService: ConfigurationService) {

  }

  public readWeight(sourceIdentifier: string): Observable<any> {

    return this.tmcHttpService.postWithContext(this.configurationService.getClientParamValue('client.io.yardconnector.url', null) + '/provider/weighing', {
      libra: sourceIdentifier
    });

  }
}
